import React from "react";
import { IconButton } from "@mui/material";
import { ReactComponent as SubmitIcon } from "../../assets/icons/Submit-Light.svg";

import { StopIcon } from "../ui/StopIcon";

/**
 * Props for the SendButton component.
 */
interface SendButtonProps {
  /** Whether the chat is currently loading/generating a response. */
  isLoading: boolean;
  /** Whether the input field is focused. */
  isFocused: boolean;
  /** Whether the input field has any text. */
  hasInput: boolean;
  /** Handler function to send the message. */
  handleSendMessage: () => void;
  /** Handler function to stop the current generation. */
  handleStopGeneration: () => void;
  /** Custom styles for the component. */
  styles: any;
}

/**
 * A button that sends a message or stops generation, depending on the current state.
 */
const SendButton: React.FC<SendButtonProps> = ({
  isLoading,
  isFocused,
  hasInput,
  handleSendMessage,
  handleStopGeneration,
  styles,
}) => {
  return (
    <IconButton
      // Call the appropriate handler based on the loading state
      onClick={isLoading ? handleStopGeneration : handleSendMessage}
      // Disable the button if not loading and there's no input
      disabled={isLoading ? false : !hasInput}
      // Apply styles based on focus, input, and loading states
      sx={styles.sendButtonActive(isFocused, hasInput, isLoading)}
      disableRipple
    >
      {/* Show the stop icon if loading, otherwise show the send icon */}
      {isLoading ? <StopIcon /> : <SubmitIcon width={22} height={22} />}
    </IconButton>
  );
};

export default SendButton;
